export const CUSTOMER_ENV_BY_STAGE = {
  dev: "dev",
  development: "dev",
  uat: "uat",
  qa: "uat",
  prod: "prod",
  production: "prod",
  staging: "dev",
};

export const OAUTH_ERROR_MESSAGES = {
  interaction_required:
    "Additional sign-in is required. Use the form below to continue.",
  missing_code_or_state: "Login was interrupted. Please try again.",
  invalid_state: "Invalid login session. Please try again.",
  customer_not_found: "Customer not found. Please check the URL or contact support.",
  identity_not_configured: "Sign-in is not configured for this customer. Please contact support.",
  token_exchange_failed:
    "Sign-in failed because the identity server is unreachable or misconfigured. Verify issuer/hosted domain, client credentials, callback URL, and network/DNS access.",
  admin_token_failed:
    "Admin sign-in failed because the identity server is unreachable or misconfigured. Verify issuer/hosted domain, client credentials, callback URL, and network/DNS access.",
  no_id_token: "Sign-in response was invalid. Please try again.",
  callback_error:
    "Sign-in callback failed because the identity server is unreachable or misconfigured. Verify callback URL and network/DNS access, then try again.",
};

export const LOGIN_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
